import React from 'react'
import { HiCheck } from "react-icons/hi"

function PlanFeature({ children }) {
    return (
        <p className="flex items-center mb-2 text-lg text-indigo-800 justify-center md:justify-start">
            <HiCheck className="mr-2 h-5 w-5 inline-flex text-green-500" />
            <span className="text-gray-900 text-sm pr-1">{children}</span>
        </p>
    )
}

export default PlanFeature

